export const INPUT_CONTACT_NUMBER = "INPUT_CONTACT_NUMBER";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_USER = "SET_USER";
export const SET_AUTH = "SET_AUTH";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_PAID_COURSE_PACKAGES = "SET_PAID_COURSE_PACKAGES";
export const SET_FREE_COURSE_PACKAGES = "SET_FREE_COURSE_PACKAGES";
